import styled from 'styled-components';

export const ViewReceiptAnchor = styled.a`
  color: ${props => props.theme.colors.capsuleGreen60} !important;

  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  line-height: ${props => props.theme.space['1.25']} !important;
`;
